import { render, staticRenderFns } from "./HKLRemindModal.vue?vue&type=template&id=662ae8b1&"
import script from "./HKLRemindModal.vue?vue&type=script&lang=js&"
export * from "./HKLRemindModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('662ae8b1')) {
      api.createRecord('662ae8b1', component.options)
    } else {
      api.reload('662ae8b1', component.options)
    }
    module.hot.accept("./HKLRemindModal.vue?vue&type=template&id=662ae8b1&", function () {
      api.rerender('662ae8b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Modal/HKLRemindModal.vue"
export default component.exports